import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { languageGet, languagePatch } from "@/common/api/rest/language";

import type { TranslationFieldsType } from "@/common/types/translation";
import type { LanguageType } from "@/common/types/language";

import { FormLanguage, ListTranslate } from "@/components";
import { breadcrumbSimple, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "language.labels.name",
    value: "",
  },
]);

const languageData = ref<LanguageType | null>(null);

const languageId = computed(() => route.params.language as string);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
  {
    key: "language",
    label: t("language.labels.languages"),
    url: `/register/language`,
  },
  {
    key: "edit",
    label: languageData.value?.name ?? "...",
  },
]);

function back() {
  router.push("/register/language");
}

// language
function fetchData() {
  languageGet(languageId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        languageData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(payload: Partial<LanguageType>) {
  languagePatch(languageId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "no-image",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("language.labels.edit_language")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(FormLanguage), {
          data: languageData.value,
          "is-patch": true,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (patchData($event)))
        }, null, 8, ["data"]),
        _createVNode(_unref(ListTranslate), {
          "owner-id": languageId.value,
          language: _unref(locale).toLowerCase(),
          fields: translationFields.value
        }, null, 8, ["owner-id", "language", "fields"])
      ])
    ])
  ]))
}
}

})